<template>
  <ElFormItem
    class="el-form-item--xl-margin"
    v-if="config.featureResendEnabled"
  >
    <small>Please check your junk folder or click resend</small>
    <el-button
      :disabled="!!resendTimeout || resendDisabled"
      @click="resendEmail"
      >Resend <span v-if="resendTimeout">({{ resendTimeout }})</span></el-button
    >
  </ElFormItem>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SideWidget from "@/modules/ui/SideWidget.vue";
import { configService } from "@/services/config-service";
import { onboardingService } from "@/services/onboarding/onboarding-service";
import { RoutesName } from "@/router";

@Options({
  components: { SideWidget },
})
export default class MessageLayout extends Vue {
  config = configService;
  resendTimeout = 0;
  sentAvailableAt = new Date();
  resendDisabled = false;

  countTime(): void {
    const current = new Date().getTime();
    this.resendTimeout = Math.round(
      (this.sentAvailableAt.getTime() - current) / 1000
    );
    if (this.resendTimeout <= 0) {
      this.resendTimeout = 0;
      this.resendDisabled = false;
      return;
    }
    setTimeout(() => this.countTime(), 1000);
  }

  async resendEmail(): Promise<void> {
    await this.$router.push({ name: RoutesName.EMAIL_SENT });
    this.resendDisabled = true;
    try {
      const { resendActiveAt } = await onboardingService.resend();
      this.sentAvailableAt = new Date(resendActiveAt);
    } catch {
      await this.$router.push({ name: RoutesName.EMAIL_ERROR });
    }

    this.countTime();
  }
}
</script>
